export enum SectionBackgroundMode {
  Default = 'default',
  Grey = 'grey',
  White = 'white',
  LightBlue = 'light-blue',
}

export enum SectionGutterMode {
  NoGutter = 'noGutter',
  Tiny = 'tiny',
  ExtraSmall = 'extraSmall',
  Small = 'small',
  Regular = 'regular',
  Medium = 'medium',
  Large = 'large',
}
